import {
  Route,
  Routes,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import LandingPage from "./camponents/LandingPage";
import Login from "./camponents/Login";
import Product from "./camponents/product/Product";
import Navbar from "./camponents/Navbar";
import AddTocart from "./camponents/product/AddTocart";
import Profile from "./camponents/Profile";
import SaleOutProduct from "./camponents/saleOutProduct/SaleOutProduct";
import SaleOutAddTocart from "./camponents/saleOutProduct/SaleOutAddTocart";
import PlaceOrder from "./camponents/product/PlaceOrder";
import SalePlaceOrder from "./camponents/saleOutProduct/SalePlaceOrder";
import OrderList from "./camponents/OrderList";
import { useEffect, useState } from "react";
import Dashboard from "./camponents/dashboard/Dashboard";
import { ProfileProvider } from "./camponents/ProfileContext";
import { requestForToken } from "./firebase";

const PrivateRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation(); // Add this line to get the location

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem("ambikaUserToken");
      const userId = localStorage.getItem("ambikaUserId");

      // Basic check - you can add API validation here if needed
      if (token && userId) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem("ambikaUserToken");
        localStorage.removeItem("ambikaUserId");
      }
      setIsValidating(false);
    };

    validateToken();
  }, []);

  if (isValidating) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/log-in" replace state={{ from: location }} />
  );
};

const AuthCheck = ({ children }) => {
  const token = localStorage.getItem("ambikaUserToken");
  const userId = localStorage.getItem("ambikaUserId");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (token && userId) {
      const from = location.state?.from?.pathname || "/dashboard";
      navigate(from, { replace: true });
    }
  }, [token, userId, navigate, location]);

  if (token && userId) {
    return null;
  }
  return children;
};
function App() {
  const location = useLocation();
  const [showNavbar, setShowNavbar] = useState(false);

  const ambikaUserToken = localStorage.getItem("ambikaUserToken");
  const ambikaUserId = localStorage.getItem("ambikaUserId");

  useEffect(() => {
    if (!ambikaUserToken || !ambikaUserId) return;

    if (!("Notification" in window)) {
      console.warn("🚫 Notifications are not supported in this browser.");
      return;
    }

    if ("Notification" in window) {
      if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            requestForToken(ambikaUserId, ambikaUserToken);
          } else {
            console.warn("🚫 Notification denied by user");
          }
        });
      }
    }
  }, [ambikaUserId, ambikaUserToken]);

  useEffect(() => {
    setShowNavbar(!["/", "/log-in"].includes(location.pathname));
  }, [location]);

  return (
    <ProfileProvider>
      <div className="App">
        {showNavbar && (
          <>
            <Navbar />
            <div style={{ height: "70px" }}></div>
          </>
        )}

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/log-in"
            element={
              <AuthCheck>
                <Login />
              </AuthCheck>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          {/* Protected Routes */}
          <Route
            path="/products"
            element={
              <PrivateRoute>
                <Product />
              </PrivateRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <PrivateRoute>
                <AddTocart />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/saleout-products"
            element={
              <PrivateRoute>
                <SaleOutProduct />
              </PrivateRoute>
            }
          />
          <Route
            path="/saleout-cart"
            element={
              <PrivateRoute>
                <SaleOutAddTocart />
              </PrivateRoute>
            }
          />
          <Route
            path="/placed-order"
            element={
              <PrivateRoute>
                <PlaceOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/saleout-placed-order"
            element={
              <PrivateRoute>
                <SalePlaceOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/order-list"
            element={
              <PrivateRoute>
                <OrderList />
              </PrivateRoute>
            }
          />

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </ProfileProvider>
  );
}

export default App;
